import I18N from '@leverege/i18n';
import { AbstractGroupScreen } from '@leverege/molten/screens';
const {
  tIcon,
  t
} = I18N.ns('openApi.SaleJobService.action.RefreshSaleJobs');
const objectType = 'SaleJobService.saleJob';
export default {
  id: 'openApi.SaleJobService.RefreshSaleJobs',
  name: 'Refresh Sale Job',
  layout: {
    sort: 'item.retry'
  },
  matches: {
    use: 'actionBar',
    objectType,
    client: AbstractGroupScreen.CLIENT
  },
  handles: cxt => {
    return true;
  },
  appearance: ({
    context
  }) => {
    return {
      name: t('name'),
      icon: tIcon('icon')
    };
  },
  perform: ({
    context
  }) => {
    const reloadData = context.reloadData || context.clientProps.reloadData;
    reloadData?.();
  }
};